import Button from "@material-ui/core/Button";
import React from "react";
import myRestClient from "../common/restClient";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import { fade } from "@material-ui/core/styles/colorManipulator";
import DownloadIcon from "@material-ui/icons/FileDownload";
import { PER_PAGE_MAX_LIMIT } from "../config";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import TranslatedText from "./TranslatedText";
import CircularProgress from "@material-ui/core/CircularProgress";

const styles = theme => ({
    exportButtonInst: {
        color: theme.palette.error.main,
        "&:hover": {
            backgroundColor: fade(theme.palette.error.main, 0.12),
            // Reset on mouse devices
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }
});

class ExportButtonInst extends React.Component {
    state = {
        downloadInProgress: false,
        showConfirmDialog: false,
        showExportDialog: false
    };
    handleDownloadInProgress = () => {
        this.setState({ downloadInProgress: true });
    };
    handleDownloadCompleted = () => {
        this.setState({ downloadInProgress: false });
    };
    handleClick = () => {
        this.setState({ showConfirmDialog: true });
    };

    handleConfirmOk = () => {
        // this.setState({ showExportDialog: true });
        // this.handleClick();
        const params = {
            filter: { export: true },
            pagination: { page: 1, perPage: PER_PAGE_MAX_LIMIT },
            sort: { field: "customer_id", order: "asc" }
        };
        if (this.state.showConfirmDialog) {
            myRestClient("GET_LIST", "installations", params).then(() => {
                this.setState({
                    showConfirmDialog: false
                });
            });
        }
        this.setState({
            showConfirmDialog: false
        });
    };

    handleConfirmCancel = () => {
        this.setState({ showConfirmDialog: false });
    };

    renderConfirmDialog() {
        return this.state.showConfirmDialog ? (
            <Dialog
                disableBackdropClick
                disableEscapeKeyDown
                maxWidth="xs"
                open={this.state.showConfirmDialog}
            >
                <DialogTitle>
                    <b>
                        <TranslatedText resource_name="ra.actions.confirm" />
                    </b>
                </DialogTitle>
                <DialogContent>
                    <TranslatedText resource_name="resources.installations.actions.export.confirm" />
                    <div align="center">
                        {this.state.downloadInProgress && <CircularProgress />}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleConfirmCancel} color="primary">
                        <TranslatedText resource_name="ra.action.cancel" />
                    </Button>
                    <Button
                        onClick={this.handleConfirmOk}
                        variant="contained"
                        color="secondary"
                        disabled={this.state.downloadInProgress}
                    >
                        <TranslatedText resource_name="resources.installations.actions.export.export_short" />
                    </Button>
                </DialogActions>
            </Dialog>
        ) : null;
    }

    render() {
        const { classes, className } = this.props;
        return (
            <div>
                <Button
                    className={classnames(
                        "ra-export-button",
                        classes.exportButtonInst,
                        className
                    )}
                    onClick={this.handleClick}
                >
                    <DownloadIcon />
                    Esporta
                </Button>
                {this.renderConfirmDialog()}
            </div>
        );
    }
}

export default withStyles(styles)(ExportButtonInst);



// WEBPACK FOOTER //
// ./src/components/ExportButtonInst.js